<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input placeholder="请输入内容" v-model="inputMore" class="input-with-select" size="small">
					    <el-select v-model="selectMore" slot="prepend" placeholder="请选择">
					    	<el-option label="请选择" value=""></el-option>
						    <el-option label="姓名" value="1"></el-option>
						    <el-option label="手机号" value="2"></el-option>
					    </el-select>
				    <el-button slot="append" icon="el-icon-search" @click="Find">查询</el-button>
				  </el-input>
				</el-form-item>
				<!--<el-form-item>
					<el-select v-model="allot" placeholder="分配经销商为..." size="small" style="width: 200px;">
	    				<el-option v-for="item in Dealerlist" :label='item.name' key="item" :value='item.id'></el-option>
	  				</el-select>
  				</el-form-item>-->
  				<!--<el-form-item>
  					<el-button type="primary" size="small" @click="Goadd">添加预约</el-button>
  				</el-form-item>-->
			<!--</el-form>
			<el-form :inline="true">-->
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">快速筛选:</el-button>
				</el-form-item>
				<el-form-item>
					<el-select v-model="State" placeholder="状态" size="small" style="width: 100px;" @change="Quickfind">
	    				<el-option label="全部状态" value=""></el-option>
	    				<el-option label="已受理" value="1"></el-option>
	    				<el-option label="未受理" value="0"></el-option>
	  				</el-select>
  				</el-form-item>
  				<el-form-item>
					<el-select v-model="Sex" placeholder="性别" size="small" style="width: 100px;" @change="Quickfind">
	    				<el-option label="全部性别" value=""></el-option>
	    				<el-option label="男" value="1"></el-option>
	    				<el-option label="女" value="2"></el-option>
	  				</el-select>
  				</el-form-item>
  				<el-form-item>
					<el-select v-model="Dealer" placeholder="所有经销商" size="small" style="width: 200px;" @change="Quickfind">
	  					<el-option label="全部经销商" value=""></el-option>
	  					<el-option v-for="item in Dealerlist" :label='item.name' :key="item.id" :value='item.id'></el-option>
					</el-select>
  				</el-form-item>
  				<el-form-item>
					<el-select v-model="Follow" placeholder="跟进状态" size="small" style="width: 130px;" @change="Quickfind">
	    				<el-option label="全部跟进状态" value=""></el-option>
	    				<el-option label="待跟进" value="0"></el-option>
	    				<el-option label="跟进中" value="1"></el-option>
	    				<el-option label="已完成" value="2"></el-option>
	    				<el-option label="已放弃" value="3"></el-option>
	  				</el-select>
  				</el-form-item>
  				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border 
				v-loading="listloading"
			 	@selection-change="handleSelectionChange"
			  	style="width: 99.9%"
			   	:max-height="maxHeight" 
			   	:row-key="getRowKeys"
                :expand-row-keys="expands"
                @row-click="rowClick"
                @current-change="toggleRowExpansion">
		    <!--<el-table-column type="selection" width="35"></el-table-column>-->
		    <el-table-column type="expand">
		      	<template slot-scope="props">
			        <el-form label-position="left" inline class="demo-table-expand">
			          	<el-form-item label="用户名：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.name}}</span>
			        	</el-form-item>
			        	<el-form-item label="年龄：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.age}}</span>
			        	</el-form-item>
			        	<el-form-item label="身高：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.height}}cm</span>
			        	</el-form-item>
			        	<el-form-item label="体重：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.weight}}kg</span>
			        	</el-form-item>
			        	<el-form-item label="微信：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.wechat}}</span>
			        	</el-form-item>
			        	<el-form-item label="预约体验点：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.experience_point}}</span>
			        	</el-form-item>
			        	<!--<el-form-item label="详细住址：" style="width: 90%;margin-bottom: 0;">
			            	<span>{{props.row.address}}</span>
			        	</el-form-item>-->
			        	<el-form-item label="病症描述：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.injury_condition}}</span>
			        	</el-form-item>
			        	<el-form-item label="详细病情描述：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.injury_segment}}</span>
			        	</el-form-item>
			        	<el-form-item label="愈后至今：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.injury_time}}</span>
			        	</el-form-item>
			        	<el-form-item label="上身、手臂能否正常抓握重物？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_1 == 1">是</span>
				            <span v-if="props.row.answer_1 == 2">否</span>
				        </el-form-item>
				          <el-form-item label="是否有骨质疏松？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_2 == 1">是</span>
				            <span v-if="props.row.answer_2 == 2">否</span>
				          </el-form-item>
				          <el-form-item label="是否有体位性低血压症状？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_3 == 1">是</span>
				            <span v-if="props.row.answer_3 == 2">否</span>
				          </el-form-item>
				          <el-form-item label="最近一个月内是否有做康复性训练？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_4 == 1">是</span>
				            <span v-if="props.row.answer_4 == 2">否</span>
				          </el-form-item>
				          <el-form-item label="是否有认知障碍？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_5 == 1">是</span>
				            <span v-if="props.row.answer_5 == 2">否</span>
				          </el-form-item>
				          <el-form-item label="最近三个月是否有通过站立架训练？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_6 == 1">是</span>
				            <span v-if="props.row.answer_6 == 2">否</span>
				          </el-form-item>
				          <el-form-item label="备注：" style="width: 100%;margin-bottom: 0;">
			            	<span>{{props.row.remarks }}</span>
			        	</el-form-item>
			        	<el-form-item style="width: 100%;margin: 0;">
			            	<span v-if="props.row.is_read == 0 && Limits.allocatedreservation_read"><el-button type="primary" size="mini" @click="Signreaded" :load="Bloading">标为已受理</el-button></span>
			            	<!--<span v-if="props.row.is_read == 1"><el-button type="primary" size="mini" @click="Signunread">标为未读</el-button></span>-->
			        	</el-form-item>
			        </el-form>
		      	</template>
    		</el-table-column>
		    <el-table-column label="状态" prop="is_read" width="70">
		    	<template slot-scope="scope">
		    		<span v-if="scope.row.is_read == 1">已受理</span>
		    		<span v-if="scope.row.is_read == 0">未受理</span>
		    	</template>
		    </el-table-column>
		    <el-table-column label="姓名" prop="name" width="80"></el-table-column>
		    <el-table-column label="性别" prop="gender.gender" width="50"></el-table-column>
		    <el-table-column label="手机" prop="phone" width="120"></el-table-column>
		    <el-table-column label="经销商" prop="dealer"></el-table-column>
		    <el-table-column label="是否本人预约" prop="is_self" width="50"></el-table-column>
		    <el-table-column label="预约来源" prop="approach" width="50"></el-table-column>
		    <el-table-column label="跟进状态" prop="follow_status" width="120">
		    	<template slot-scope="scope">
		    		<el-select v-if="Limits.allocatedreservation_followStatus" v-model="scope.row.follow_status" slot="prepend" placeholder='' size="mini" @change="Cfollow(scope.$index,scope.row)">
					    <el-option label="待跟进" value="0"></el-option>
	    				<el-option label="跟进中" value="1"></el-option>
	    				<el-option label="已完成" value="2"></el-option>
	    				<el-option label="已放弃" value="3"></el-option>
					</el-select>
					<el-select disabled v-if="!Limits.allocatedreservation_followStatus" v-model="scope.row.follow_status" slot="prepend" placeholder='' size="mini">
					</el-select>
		    	</template>
		    </el-table-column>
		    <el-table-column label="常住地" prop="address.totalAddress"></el-table-column>
		    <el-table-column label="预约时间" prop="submit_date" :formatter="dateFormat" width="160"></el-table-column>
		    <!--<el-table-column label="审核状态" prop="is_audit" width="80"></el-table-column>-->
		    <!--<el-table-column label="操作" width="100">
		    	<template slot-scope="scope">
		    		<el-button type="primary" size="mini" @click="Sign(scope.$index,scope.row)">标为已读</el-button>
		    	</template>
		    </el-table-column>-->
  		</el-table>
  		
  		<el-col :span="24" class="toolbar downtool">
  			<!--<el-button type="danger" size="small" @click="BatchDelete" :disabled="this.sels.length===0">勾选删除</el-button>-->
        	<!--<el-button type="primary" size="small" @click="ShowDeleted">显示已删除预约</el-button>-->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;"></el-pagination>
		</el-col>
	</div>
</template>

<script>
	import {GetAllocatedlist,GetDealerlist} from '../api/api';
	
	export default {
		data (){
			return {
				token:"",
				maxHeight:600,
				Limits:"",
				inputMore:"",
				selectMore:"",
//				allot:"",
				List:[],
				sels:[],
				listloading:false,
				State:"",
				Sex:"",
				Dealer:"",
				Follow:"",
				Audit:"",
				Pagesize:20,
				Curpage:1,
				total:1,
				Dealerlist:[],
				getRowKeys(row) {
            		return row.id;
        		},
        		form:{},
        		expands:[],
        		Bid:"",
        		Screenall:{},
        		Bloading:false,
        		Form:{
        			id:""
        		}
			}
		},
		methods:{
			Find(){
				if(this.selectMore && this.inputMore){
					this.Quickfind()
				}
			},
			Quickfind(){
				var all
				if(this.selectMore && this.inputMore){
					if(this.selectMore == 1){
						all = {
							name:'~'+this.inputMore,
							is_read:this.State,
							gender_code:this.Sex,
							dealer_id:this.Dealer,
							follow_status:this.Follow
						}
					}else if(this.selectMore == 2){
						all = {
							phone:'~'+this.inputMore,
							is_read:this.State,
							gender_code:this.Sex,
							dealer_id:this.Dealer,
							follow_status:this.Follow
						}
					}
				}else{
					all = {
						is_read:this.State,
						gender_code:this.Sex,
						dealer_id:this.Dealer,
						follow_status:this.Follow
					}
				}
				this.Screenall = {}
				for(var i in all){
					if(all[i]){
						this.Screenall[i] = all[i]
							continue
						}
				}
				if(this.State || this.Sex || this.Dealer || this.Follow || (this.selectMore && this.inputMore)){
					this.GetList(GetAllocatedlist,{page:this.Curpage,token:this.token,sort:"-submit_date",q:JSON.stringify([{"AND":this.Screenall}])})
				}else{
					this.GetList(GetAllocatedlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
				}
				
			},
			handleSelectionChange(sels){
				this.sels = sels;
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Quickfind()
			},
			Refresh(){
				this.selectMore = ""
				this.inputMore = ""
				this.State = ""
				this.Sex = ""
				this.Dealer = ""
				this.Follow = ""
				this.Curpage = 1
				this.GetList(GetAllocatedlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
			},
//			标为已受理
			Signreaded(){
				this.Bloading = true
				this.listloading = true
				let url = "/allocatedreservations/"+this.Bid+"/readstatus?token="+this.token
				this.axios.put(url).then(res => {
					if(res.status == "200"){
						this.$message({
			            	type: 'success',
			            	message: '操作成功!'
			          	});
			          	this.Bloading = false
			          	this.GetList(GetAllocatedlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
					}else{
						this.$message.error('对不起，请求失败。')
						this.Bloading = false
						this.listloading = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.Bloading = false
					this.listloading = false
				})
			},
//			标为未受理			
			Signunread(){
				console.log(this.Bid)
			},
//			Goadd(){
//				window.open("http://www.baidu.com");  
//			},
			rowClick(row){
//				console.log(row.id)
				this.Bid = row.id
			},
			toggleRowExpansion(row){
            	this.expands = [];
            	this.expands.push(row.id);
       		},
       		Cfollow(index,row){
       			this.listloading = true
       			this.Form = Object.assign({}, row);
       			console.log(this.Form.id)
//     			console.log(row.follow_status)
				let ull = "/allocatedreservations/"+this.Form.id+"/followStatus?token="+this.token
				this.axios.put(ull,{"follow_status":row.follow_status}).then(res => {
					console.log(res)
					for(var key in res.data.items){
								for(var i=0;i<this.List.length;i++){
									if(this.List[i].id == key){
										this.List[i].follow_status = res.data.items[key]
									}
								}
							}
							this.listloading = false
							
					if(res.status == "200"){
						this.$message({
				            type: 'success',
				            message: '操作成功!'
				        });
				        for(var key in res.data.items){
							for(var i=0;i<this.List.length;i++){
								if(this.List[i].id == key){
									this.List[i].follow_status = res.data.items[key]
								}
							}
						}
						this.listloading = false
					}else{
						this.$message.error('对不起，请求失败。')
						this.listloading = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.listloading = false
				})
       		}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetList(GetAllocatedlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
			this.GetDealerList(GetDealerlist)
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>
	.el-select{
		width: 100px;
	}
	.el-select .el-input {
	    width: 130px;
	  }
  	.input-with-select .el-input-group__prepend {
	    background-color: #fff;
	  }
	  
	.el-form--inline .el-form-item{
		margin-right: 0;
	}
</style>


// WEBPACK FOOTER //
// CustomerReservationed.vue?9ba05fa4